module.exports = __webpack_public_path__ + "img/de.903d6a16.svg";